import { get, join } from 'lodash'
import IndexComponent from '../common/IndexComponent'
import indexActions from '../../actions/DentalBenefitsSets'
import platformActions from '../../actions/Platforms'
import { BenefitsSetIndex, connectedBenefitsSetIndex } from '../BenefitsSet/BenefitsSetIndex'
import BenefitsSetsHelper from '../BenefitsSet/Helpers/BenefitsSetsHelper'
import approvalStateDisplay from '../BenefitsSet/approvalStateDisplay'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'
import ratesStatusDisplay from '../BenefitsSet/ratesStatusDisplay'

const filters = [
  {
    key: 'audience',
    config: 'benefits.audience'
  },
  {
    key: 'approval_state',
    options: [
      { value: 'new', text: 'New' },
      { value: 'approved', text: 'Approved' },
      { value: 'rejected', text: 'Rejected' },
      { value: 'corrected', text: 'Corrected' },
      { value: 'amended', text: 'Amended' }
    ]
  },
  {
    key: 'publish_state',
    options: [
      { value: 'needs_publishing', text: 'Needs Publishing' },
      { value: 'failed_to_publish', text: 'Failed to publish' },
      { value: 'published', text: 'Published' },
      { value: 'unpublished', text: 'Unpublished' },
      { value: 'publishing', text: 'Publishing' }
    ]
  },
  {
    key: 'plan_years',
    options: BenefitsSetsHelper.planYearOptions(2015, (new Date()).getFullYear() + 1)
  },
  {
    key: 'networks',
    options: [
      { value: 'true', text: 'Mapped' },
      { value: 'false', text: 'Not Mapped' }
    ]
  },
  {
    key: 'ancillary_privileged_platforms',
    path: 'platforms.index',
    actions: {
      records: platformActions.index.main,
      reset: platformActions.index.reset
    }
  },
  {
    key: 'states',
    options: (state) => {
      return state.login.session.configuration.states.map((s) => {
        return { text: s.text, value: s.name }
      })
    }
  }
]

const columnsList = [
  { key: 'name', label: 'Name', display: BenefitsSetIndex.showLinkDisplay('/dental_benefits') },
  {
    key: 'states',
    label: 'States',
    sortable: false,
    filterable: true,
    recordValue: 'value',
    recordLabel: 'text'
  },
  { key: 'issuer_name', label: 'Issuer' },
  { key: 'issuer_id', label: 'Issuer ID' },
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },
  {
    key: 'ancillary_privileged_platforms',
    label: 'Platforms',
    sortable: false,
    filterable: true,
    remoteKey: 'ancillary_privileged_platforms',
    recordValue: 'name',
    display: (value) => {
      return join(get(value, 'ancillary_privileged_platforms'), ', ')
    }
  },
  { key: 'hios_ids', label: 'HIOS IDs', sortable: false },
  {
    key: 'audience',
    label: 'Audience',
    filterable: true,
    optionsEnum: true
  },
  {
    key: 'plan_years',
    label: 'Years',
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'rate_factor_set_name',
    label: 'Rate Factor Set',
    display: BenefitsSetIndex.showRateFactorSetLinkDisplay
  },
  {
    key: 'service_area_name',
    label: 'Service Area',
    display: BenefitsSetIndex.showServiceAreaLinkDisplay
  },
  { key: 'updated_at', label: 'Last Updated At', display: IndexComponent.dateTimeDisplay },
  { key: 'last_updated_by_username', label: 'Last Updated By' },
  {
    key: 'approval_state',
    label: 'Status',
    display: approvalStateDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'networks',
    label: 'Networks',
    sortable: false,
    display: BenefitsSetIndex.networksDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  }
]

const ipaViewColumnsList = [
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },
  { key: 'issuer_id', label: 'Issuer ID' },
  {
    key: 'audience',
    label: 'Audience',
    filterable: true,
    optionsEnum: true
  },
  {
    key: 'plan_years',
    label: 'Years',
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'name',
    label: 'Name',
    display: BenefitsSetIndex.showLinkDisplay('/dental_benefits')
  },
  {
    key: 'states',
    label: 'States',
    sortable: false,
    filterable: true,
    recordValue: 'value',
    recordLabel: 'text'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'service_area_name',
    label: 'Service Area',
    display: BenefitsSetIndex.showServiceAreaLinkDisplay
  },
  {
    key: 'rate_factor_set_name',
    label: 'Rate Factor Set',
    display: BenefitsSetIndex.showRateFactorSetLinkDisplay
  },
  {
    key: 'ancillary_rate_factor_set_status',
    label: 'Rates Status',
    display: ratesStatusDisplay,
    recordLabel: 'text',
    recordValue: 'value'
  }
]

export default connectedBenefitsSetIndex(
  'dentalBenefitsSets',
  indexActions,
  filters,
  {
    name: 'Dental Benefits Set',
    columnsList,
    ipaViewColumnsList,
    benefitsSetPath: '/dental_benefits',
    includeBulkEditLink: true,
    includeNewRecordLink: true,
    includeDiffSetLink: true,
    includeCsvExportLink: true,
    includeSelectAll: true,
    productLine: 'dental',
    searchPlaceholder: 'Search by Name, HIOS ID, Vericred ID, Issuer ID, Service Area ID, or Rate Factor Set ID',
    searchColumns: ['name',
      'vericred_id',
      'hios_id',
      'issuer_id',
      'document_id',
      'service_area_id',
      'rate_factor_set_id']
  }
)

